import { render, staticRenderFns } from "./VWysiwyg.vue?vue&type=template&id=29c08f44"
import script from "./VWysiwyg.vue?vue&type=script&lang=js"
export * from "./VWysiwyg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports